export const buildCatalogServiceQuery = (filters: any) => {
  const { state, cloudTypes, orderable, nameOrSubtitle } = filters;
  let query = `query { 
    actualCatalogServices(
      filterCatalogsDTO: {`;
  const isCloudTypes = cloudTypes?.length;
  const isState = state && state?.length;
  const isNameOrSubtitle = nameOrSubtitle && nameOrSubtitle?.length;
  if (isCloudTypes) {
    query += `
      cloudTypes: [${cloudTypes}]
      `;
  }
  if (isState) {
    query += `
      state: ${state}
      `;
  }
  if (isNameOrSubtitle) {
    query += `
      name: "${nameOrSubtitle}"
      `;
  }
  if (orderable) {
    query += `
      orderable: true
      `;
  }
  query += `}
    ) {
      serviceCategories {
        name
        description
        id
        categoryId
        positioningMessages {
          message
        }
        infraServices {
          id
          subtitle
          apmid
          icon
          categoryName
          isCatalogPart
          orderable
          description
          displayName
          pavedRoad
          serviceName
          state
          cloudType
          type
          parentServiceDisplayName
          serviceId
          parentServiceId
        }
        serviceCategories {
          name
          description
          id
          categoryId
          positioningMessages {
            message
          }
          infraServices {
            id
            apmid
            icon
            categoryName
            isCatalogPart
            subtitle
            orderable
            description
            displayName
            pavedRoad
            serviceName
            cloudType
            state
            type
            parentServiceDisplayName
            serviceId
            parentServiceId
          }
        }
      }
    }
  }`;
  return query;
};
